// Interparcel Australia Service and Country Codes Constants

import type {
  InterparcelService,
  InterparcelCountry,
  InterparcelServiceType,
  InterparcelServiceLevel,
  InterparcelPickupType,
} from './types';

// Constants

export const DOMESTIC_SERVICE_TYPES: ReadonlyArray<InterparcelServiceType> = [
  'Pallet',
  'Standard',
  'Express',
  'Same Day',
  'Timed',
];

export const INTERNATIONAL_SERVICE_TYPES: ReadonlyArray<InterparcelServiceType> = [
  'Standard',
  'Express',
  'Pallet',
];

export const SERVICE_LEVELS: ReadonlyArray<InterparcelServiceLevel> = [
  'standard',
  'express',
  'timed',
  'sameday',
  'pallet',
];

export const PICKUP_TYPES: ReadonlyArray<InterparcelPickupType> = ['collection', 'dropoff'];

export const AUSTRALIA_DOMESTIC_SERVICES: ReadonlyArray<InterparcelService> = [
  { name: 'Allied Pallet B2B', code: 'ALLPAL', type: 'Pallet' },
  { name: 'Allied Pallet Taillift', code: 'ALLPALT', type: 'Pallet' },
  { name: 'Allied Road Express', code: 'ALLROEXP', type: 'Standard' },
  { name: 'Allied Road Express ATL', code: 'ALLROEXPA', type: 'Standard' },
  { name: 'Allied Road Express B2B', code: 'ALLROEXPB', type: 'Standard' },
  { name: 'Allied Road Express B2B ATL', code: 'ALLROEXPBA', type: 'Standard' },
  { name: 'Aramex Road', code: 'FASRD', type: 'Standard' },
  { name: 'Aramex Road ATL', code: 'FASRDATL', type: 'Standard' },
  { name: 'Australia Post eParcel Post Returns', code: 'PR', type: 'Standard' },
  { name: 'Australia Post Express eParcel Post Returns', code: 'XPR', type: 'Express' },
  { name: 'Australia Post Express Post (3K55)', code: '3K55', type: 'Express' },
  { name: 'Australia Post Express Post (7I55)', code: '7I55', type: 'Express' },
  { name: 'Australia Post Express Post (7J85)', code: '7J85', type: 'Express' },
  { name: 'Australia Post Express Post (over 5kg)', code: 'B21', type: 'Express' },
  { name: 'Australia Post Express Post (up to 5kg)', code: 'B20', type: 'Express' },
  { name: 'Australia Post Express Post + Signature (3J55)', code: '3J55', type: 'Express' },
  { name: 'Australia Post Express Post + Signature (3J85)', code: '3J85', type: 'Express' },
  {
    name: 'Australia Post Express Post Flat Rate Box (Extra Large)',
    code: 'BE9PB4',
    type: 'Express',
  },
  { name: 'Australia Post Express Post Flat Rate Box (Large)', code: 'BE9PB3', type: 'Express' },
  { name: 'Australia Post Express Post Flat Rate Box (Medium)', code: 'BE9PB2', type: 'Express' },
  { name: 'Australia Post Express Post Flat Rate Box (Small)', code: 'BE9PB1', type: 'Express' },
  {
    name: 'Australia Post Express Post Flat Rate Satchel 5kg (Extra Large)',
    code: 'BE9P50',
    type: 'Express',
  },
  {
    name: 'Australia Post Express Post Flat Rate Satchel 5kg (Large)',
    code: 'BE9P30',
    type: 'Express',
  },
  {
    name: 'Australia Post Express Post Flat Rate Satchel 5kg (Medium)',
    code: 'BE9P10',
    type: 'Express',
  },
  {
    name: 'Australia Post Express Post Flat Rate Satchel 5kg (Small)',
    code: 'BE9P05',
    type: 'Express',
  },
  { name: 'Australia Post Parcel Post (7C55)', code: '7C55', type: 'Standard' },
  { name: 'Australia Post Parcel Post (7D85)', code: '7D85', type: 'Standard' },
  { name: 'Australia Post Parcel Post (7E55)', code: '7E55', type: 'Standard' },
  { name: 'Australia Post Parcel Post (over 5kg)', code: 'B31', type: 'Standard' },
  { name: 'Australia Post Parcel Post (up to 5kg)', code: 'B30', type: 'Standard' },
  { name: 'Australia Post Parcel Post + Signature (3D55)', code: '3D55', type: 'Standard' },
  { name: 'Australia Post Parcel Post + Signature (3D85)', code: '3D85', type: 'Standard' },
  {
    name: 'Australia Post Parcel Post Flat Rate Box (Extra Large)',
    code: 'BE1PB4',
    type: 'Standard',
  },
  { name: 'Australia Post Parcel Post Flat Rate Box (Large)', code: 'BE1PB3', type: 'Standard' },
  { name: 'Australia Post Parcel Post Flat Rate Box (Medium)', code: 'BE1PB2', type: 'Standard' },
  { name: 'Australia Post Parcel Post Flat Rate Box (Small)', code: 'BE1PB1', type: 'Standard' },
  {
    name: 'Australia Post Parcel Post Flat Rate Satchel 5kg (Extra Large)',
    code: 'BE1P50',
    type: 'Standard',
  },
  {
    name: 'Australia Post Parcel Post Flat Rate Satchel 5kg (Large)',
    code: 'BE1P30',
    type: 'Standard',
  },
  {
    name: 'Australia Post Parcel Post Flat Rate Satchel 5kg (Medium)',
    code: 'BE1P10',
    type: 'Standard',
  },
  {
    name: 'Australia Post Parcel Post Flat Rate Satchel 5kg (Small)',
    code: 'BE1P05',
    type: 'Standard',
  },
  { name: 'Australia Post Post Wine + Signature (3P85)', code: '3P85', type: 'Standard' },
  { name: 'Bonds Express', code: 'BONEXP', type: 'Same Day' },
  { name: 'Bonds Pallet', code: 'BONPAL', type: 'Pallet' },
  { name: 'Bonds Pallet Taillift', code: 'BONPALT', type: 'Pallet' },
  { name: 'Bonds Standard', code: 'BONSTA', type: 'Same Day' },
  { name: 'Bonds VIP', code: 'BONVIP', type: 'Same Day' },
  { name: 'Couriers Please Box', code: 'CPBOX', type: 'Standard' },
  { name: 'Couriers Please Box ATL', code: 'CPBOXA', type: 'Standard' },
  { name: 'Couriers Please Road', code: 'CPRO', type: 'Standard' },
  { name: 'Couriers Please Road ATL', code: 'CPROA', type: 'Standard' },
  { name: 'Courrio Road', code: 'COURR', type: 'Standard' },
  { name: 'Courrio Road ATL', code: 'COURRA', type: 'Standard' },
  { name: 'CRL Express B2B Pallet', code: 'CRLEB2BPAL', type: 'Pallet' },
  { name: 'CRL Express B2B Pallet Taillift', code: 'CRLEB2BPALT', type: 'Pallet' },
  { name: 'Direct Couriers Elite', code: 'DCEL', type: 'Same Day' },
  { name: 'Direct Couriers Express', code: 'DCEXP', type: 'Same Day' },
  { name: 'Direct Couriers Regular', code: 'DCREG', type: 'Same Day' },
  { name: 'FedEx Domestic 10am Express', code: 'FXDOM10', type: 'Timed' },
  { name: 'FedEx Domestic 12pm Express', code: 'FXDOM12', type: 'Timed' },
  { name: 'FedEx Domestic 9am Express', code: 'FXDOM9', type: 'Timed' },
  { name: 'FedEx Domestic Interstate', code: 'FEDEXIS', type: 'Same Day' },
  { name: 'FedEx Domestic Overnight', code: 'FXDOMO', type: 'Express' },
  { name: 'FedEx Domestic Pallet B2B', code: 'FXPALB2B', type: 'Pallet' },
  { name: 'FedEx Domestic Pallet B2C', code: 'FXPALB2C', type: 'Pallet' },
  { name: 'FedEx Domestic Pallet Taillift B2B', code: 'FXPALTB2B', type: 'Pallet' },
  { name: 'FedEx Domestic Pallet Taillift B2C', code: 'FXPALTB2C', type: 'Pallet' },
  { name: 'FedEx Domestic Road Express', code: 'FXDOMR', type: 'Standard' },
  { name: 'FedEx Domestic Road Express B2B', code: 'FXDOMREB2B', type: 'Standard' },
  { name: 'FedEx Domestic Road Express B2C', code: 'FXDOMRB', type: 'Standard' },
  { name: 'Freight Flex Next Day', code: 'FFLEXND', type: 'Standard' },
  { name: 'Freight Flex Same Day', code: 'FFLEXSD', type: 'Same Day' },
  { name: 'Hi-Trans Express Pallet B2B', code: 'HITPALB2B', type: 'Pallet' },
  { name: 'Hi-Trans Express Pallet Taillift B2B', code: 'HITPALTB2B', type: 'Pallet' },
  { name: 'Hunter Express Pallet', code: 'HEPAL', type: 'Pallet' },
  { name: 'Hunter Express Pallet B2B', code: 'HEPALB2B', type: 'Pallet' },
  { name: 'Hunter Express Pallet Taillift', code: 'HEPALT', type: 'Pallet' },
  { name: 'Hunter Express Pallet Taillift B2B', code: 'HEPALTB2B', type: 'Pallet' },
  { name: 'Hunter Express Road', code: 'HEROAD', type: 'Standard' },
  { name: 'Hunter Express Road ATL', code: 'HEROADATL', type: 'Standard' },
  { name: 'Hunter Express Road B2B', code: 'HEROADB2B', type: 'Standard' },
  { name: 'Hunter Express Road B2B ATL', code: 'HEROADAB2B', type: 'Standard' },
  { name: 'Interparcel Domestic 12pm', code: 'DHLDOM12', type: 'Timed' },
  { name: 'Interparcel Domestic 9am', code: 'DHLDOM9', type: 'Timed' },
  { name: 'Interparcel Domestic Express', code: 'DHLDOMEXP', type: 'Express' },
  { name: 'Northline B2B Pallet', code: 'NTHB2BPAL', type: 'Pallet' },
  { name: 'Northline B2B Pallet Taillift', code: 'NTHB2BPALT', type: 'Pallet' },
  { name: 'Northline B2B Road', code: 'NTHB2BR', type: 'Standard' },
  { name: 'Northline B2C Pallet Taillift', code: 'NTHB2CPALT', type: 'Pallet' },
  { name: 'Northline B2C Road', code: 'NTHB2CR', type: 'Standard' },
  { name: 'StarTrack Express', code: 'STEXP', type: 'Standard' },
  { name: 'StarTrack Express ATL', code: 'STEXPA', type: 'Standard' },
  { name: 'StarTrack National Premium', code: 'STNP', type: 'Express' },
  { name: 'StarTrack National Premium ATL', code: 'STNPA', type: 'Express' },
  { name: 'StarTrack Next Flight', code: 'STNF', type: 'Same Day' },
  { name: 'StarTrack Premium', code: 'STPRE', type: 'Express' },
  { name: 'StarTrack Premium ATL', code: 'STPREA', type: 'Express' },
];

export const INTERNATIONAL_SERVICES: ReadonlyArray<InterparcelService> = [
  { name: 'Asendia e-PAQ Select Bulk', code: 'ASENESB', type: 'Standard' },
  { name: 'Australia Post International Airmail', code: 'AIR8', type: 'Standard' },
  { name: 'Australia Post International Economy', code: 'RPI8', type: 'Standard' },
  { name: 'Australia Post International Express - Docs', code: 'ECD8', type: 'Express' },
  { name: 'Australia Post International Express - Merchandise', code: 'ECM8', type: 'Express' },
  { name: 'Australia Post International Parcels - Express Merch', code: 'I67', type: 'Standard' },
  { name: 'Australia Post International Parcels - Standard Large', code: 'I65', type: 'Standard' },
  { name: 'Australia Post International Standard', code: 'PTI8', type: 'Standard' },
  { name: 'Australia Post International Standard + Signature', code: 'PTI7', type: 'Standard' },
  { name: 'DHL eCommerce Packet Plus', code: 'DHLPP', type: 'Standard' },
  { name: 'DHL eCommerce Packet Plus Bulk', code: 'DHLPPB', type: 'Standard' },
  { name: 'DHL eCommerce Parcel Direct', code: 'DHLPD', type: 'Standard' },
  { name: 'DHL eCommerce Parcel Direct Bulk', code: 'DHLPDB', type: 'Standard' },
  { name: 'FX Connect Plus', code: 'FXCONP', type: 'Express' },
  { name: 'FX Economy', code: 'FXECO', type: 'Standard' },
  { name: 'FX Economy Freight', code: 'FXECOF', type: 'Pallet' },
  { name: 'FX Priority', code: 'FXPRI', type: 'Express' },
  { name: 'FX Priority Freight', code: 'FXPRIF', type: 'Pallet' },
  { name: 'Interparcel Document Express', code: 'DHLDOCEXP', type: 'Express' },
  { name: 'Interparcel Express', code: 'DHLEXP', type: 'Express' },
  { name: 'UPS Express', code: 'UPSEXP', type: 'Express' },
  { name: 'UPS Express Freight', code: 'UPSEXPF', type: 'Pallet' },
  { name: 'UPS Express Saver', code: 'UPSEXPSVR', type: 'Express' },
];

export const COUNTRIES: ReadonlyArray<InterparcelCountry> = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antigua & Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Azores', code: 'A2' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bonaire', code: 'BQ' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Virgin Islands', code: 'VG' },
  { name: 'Brunei', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burma', code: 'MM' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Canary Islands', code: 'IC' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Rep', code: 'CF' },
  { name: 'Ceuta', code: 'EA' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Curacao', code: 'CW' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'East Timor', code: 'TL' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Gaza', code: 'PS' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'ID' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland (Republic of)', code: 'IE' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Ivory Coast', code: 'CI' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea (South)', code: 'KR' },
  { name: 'Kosrae', code: 'FM' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Laos', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macau', code: 'MO' },
  { name: 'Macedonia', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Madeira', code: 'PT' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Melilla', code: 'EA' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Poland', code: 'PL' },
  { name: 'Ponape', code: 'FM' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion Island', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Rota', code: 'MP' },
  { name: 'Russia', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saba', code: 'BQ' },
  { name: 'Saipan', code: 'MP' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome & Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somaliland', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'St. Barthelemy', code: 'BL' },
  { name: 'St. Christopher', code: 'KN' },
  { name: 'St. Croix (US Virgin Islands)', code: 'VI' },
  { name: 'St. Eustacius', code: 'BQ' },
  { name: 'St. John (US Virgin Islands)', code: 'VI' },
  { name: 'St. Kitts and Nevis', code: 'KN' },
  { name: 'St. Lucia', code: 'LC' },
  { name: 'St. Maarten', code: 'SX' },
  { name: 'St. Martin (Guadeloupe)', code: 'MF' },
  { name: 'St. Thomas (US Virgin Islands)', code: 'VI' },
  { name: 'St. Vincent & the Grenadines', code: 'VC' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syria', code: 'SY' },
  { name: 'Taiwan', code: 'TW' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Tinian', code: 'TI' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Tortola', code: 'VG' },
  { name: 'Trinidad & Tobago', code: 'TT' },
  { name: 'Truk', code: 'TU' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks & Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'UK', code: 'GB' },
  { name: 'UK - Highlands & Islands', code: 'GB' },
  { name: 'UK - Isle Of Wight', code: 'GB' },
  { name: 'UK - Northern Ireland', code: 'GB' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'Union Islands', code: 'VC' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'US Virgin Islands', code: 'VI' },
  { name: 'USA', code: 'US' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Virgin Gorda', code: 'VR' },
  { name: 'Wallis & Futuna Islands', code: 'WF' },
  { name: 'Yap', code: 'YA' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];
